// Shared number-formatting helpers for the Storage Tracking page.
// Adds thousands separators (e.g. "100,000") to numeric fields.

export const formatThousands = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value).trim();
  if (str === "") return "";

  const isNegative = str.startsWith("-");
  const digitsOnly = str.replace(/[^0-9]/g, "");
  if (digitsOnly === "") return isNegative ? "-" : "";

  const formatted = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return isNegative ? `-${formatted}` : formatted;
};

// Adds thousands separators to a number's integer part while preserving
// its decimal part, e.g. 2500300.5 -> "2,500,300.5".
export const formatNumberThousands = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return "";

  const isNegative = num < 0;
  const [intPart, decPart] = Math.abs(num).toString().split(".");
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formatted = decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
  return isNegative ? `-${formatted}` : formatted;
};

export const stripCommas = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/,/g, "");
};

// Keeps digits and a single decimal point, truncated to `maxDecimals` places.
export const sanitizeDecimal = (value, maxDecimals = 16) => {
  if (value === null || value === undefined) return "";
  let cleaned = String(value).replace(/[^0-9.]/g, "");
  const firstDot = cleaned.indexOf(".");
  if (firstDot !== -1) {
    cleaned =
      cleaned.slice(0, firstDot + 1) +
      cleaned.slice(firstDot + 1).replace(/\./g, "");
  }
  const [intPart, decPart] = cleaned.split(".");
  if (decPart !== undefined) {
    return `${intPart}.${decPart.slice(0, maxDecimals)}`;
  }
  return cleaned;
};
